import React from "react";

// Evidence/references block shown below the question card on a quiz's first
// screen. Reinforces Sarv's "evidence-based" positioning honestly: it frames the
// quiz as an educational tool grounded in published research on the relevant
// themes — NOT as a validated diagnostic instrument. Sources are real and link
// out to NIH / NCCIH / WHO / peer-reviewed reviews.
const QuizEvidence = ({ note, references }) => {
  if (!references || references.length === 0) return null;
  return (
    <section className="quiz-evidence" aria-label="Evidence and references">
      <p className="quiz-evidence__label">The evidence behind this quiz</p>
      {note && <p className="quiz-evidence__note">{note}</p>}
      <ol className="quiz-evidence__refs">
        {references.map((r, i) => (
          <li key={i}>
            <a href={r.url} target="_blank" rel="noopener noreferrer">
              {r.label}
            </a>
            {r.publisher ? <span className="quiz-evidence__pub"> — {r.publisher}</span> : null}
          </li>
        ))}
      </ol>
    </section>
  );
};

export default QuizEvidence;
